import { render, staticRenderFns } from "./EditPromoCode.vue?vue&type=template&id=08a652ef&scoped=true"
import script from "./EditPromoCode.vue?vue&type=script&lang=js"
export * from "./EditPromoCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a652ef",
  null
  
)

export default component.exports